import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Core } from "@faire/design-tokens";
import { Column } from "@faire/web--source/slate/Layout";
import { Spacer } from "@faire/web--source/slate/spacing";
import * as React from "react";
import styled from "styled-components";
export var MakerSignUpFooterWrapper = function(param) {
    var children = param.children;
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(Spacer, {
                size: "10x"
            }),
            /*#__PURE__*/ _jsx(MobileStickyFooter, {
                children: children
            })
        ]
    });
};
var MobileStickyFooter = styled(Column).withConfig({
    componentId: "sc-5188d5d6-0"
})([
    "width:100%;position:fixed;bottom:0;left:0;background-color:",
    ";"
], Core.surface.inverse);
